import React from 'react';
import PropTypes from 'prop-types';
import chevron from '../../../../assets/images/promos/chevron.svg';
import TidalLogo from '../../../../assets/images/promos/tidal/tidal-logo-black.svg';

const PromoTidalCheckout = ({ expand, isExpanded }) => (
  <div className="c-promo-tidal-checkout u-float-right">
    <div className="c-promo-tidal-checkout_right">
      <div>
        <div className="c-promo-tidal-checkout_main">
          <p>
            Finalize this transaction and you will receive<br />
            <b>2 free months of music streaming with TIDAL</b>
          </p>
          <img className="c-promo-modal_logo" src={TidalLogo} alt="TIDAL" />
        </div>
      </div>
    </div>
    {!isExpanded && <div className="c-promo-tidal-checkout_expand" >
      <button onClick={expand}>
        more
        <img src={chevron} alt="Expand Promotion" />
      </button>
    </div>}
    {isExpanded && (<div className="c-promo-tidal-checkout_left">
      <div>
        Other benefits to paying now
      </div>
      <ul>
        <li>save time by not having to wait to pay</li>
        <li>stay safe and sanitary by touching fewer surfaces</li>
      </ul>
    </div>)}
    <div className="c-promo-tidal-checkout_terms">
      Not available for current or past TIDAL subscribers
        <br />TIDAL Terms & Conditions apply
      </div>
  </div>
);

PromoTidalCheckout.propTypes = {
  isExpanded: PropTypes.bool.isRequired,
  expand: PropTypes.func.isRequired,
};

export default PromoTidalCheckout;



// WEBPACK FOOTER //
// ./src/app/reservation/components/PromoTidalCheckout.jsx